/** @file Weights panel registration: mesh binding, influences, brush and mesh-edit options. */
import type { PanelEntry } from '../panelEntry';
import { WeightsPanel } from './WeightsPanel';

/** A form panel (default renderer); its tools' keys belong to the viewport, so it binds none. */
export const panel: PanelEntry = { id: 'weights', title: 'panels.weights.title', bindings: [], component: WeightsPanel };
